export default "__VITE_ASSET__088f1bc2__"